/** English (US) locale for system-settings-ui. */
export const systemSettingsEnUs = {
  systemSettings: {
    title: `System Settings`,
    tabs: {
      general: `General`,
      defaults: `Defaults`,
      recording: `Call Recording`,
    },
    common: {
      save: `Save Changes`,
      active: `Active`,
      inactive: `Inactive`,
      yes: `Yes`,
      no: `No`,
      loading: `Loading...`,
      selectOption: `-- Select --`,
      none: `None`,
      unsavedChanges: `Unsaved changes`,
    },
    general: {
      title: `General`,
      defaultTimeZone: `Default Time Zone`,
      callParkTimeout: `Call Park Timeout (seconds)`,
      callParkTimeoutHelp:
        'Time in seconds a call remains parked before returning. Minimum 30 seconds, maximum 1800 seconds. Recommended: 300.',
      callParkWarning: `Are you sure you want to leave callers in the parking lot for {{minutes}} minutes?`,
      extensionsTitle: `Extensions`,
      extensionDigits: `Extension Digits`,
      enableIntercom: `Enable Intercom`,
      searchTimezone: 'Search timezones...',
      noTimezonesFound: 'No timezones found',
    },
    defaults: {
      voiceTitle: `Voice`,
      defaultAreaCode: `Default Area Code`,
      areaCodeRange: `Area code must be between 200 and 998`,
      areaCodeDisallowed: `This area code is not allowed`,
      defaultCallerId: `Default Caller ID`,
      faxTitle: `Fax`,
      defaultFaxNumber: `Default Fax Number`,
      defaultVirtualFax: `Default Virtual Fax`,
      defaultVirtualFaxSearchPlaceholder: `Search virtual fax extensions...`,
      defaultVirtualFaxSearchAriaLabel: `Search virtual fax extensions by name or number`,
      defaultVirtualFaxNoMatches: `No virtual fax extension matches that search.`,
      emergencyTitle: `Emergency Defaults`,
      emergencyName: `Emergency Name`,
      emergencyNumber: `Emergency Number`,
      emergencyNumberHelp: `This field is read-only and cannot be changed here.`,
      emergencyAlert: `Emergency Alert`,
      holdMusicTitle: `Hold Music`,
      holdMusicPlaylist: `Hold Music`,
      noPlaylists: `No playlists available`,
      playlistNotPlayableSuffix: `(no audio tracks)`,
      playlistEmptyError: `The selected hold music playlist has no audio tracks. Add tracks or choose a different playlist.`,
    },
    recording: {
      title: `Call Recording`,
      enableInbound: `Enable Inbound Call Recording`,
      enableOutbound: `Enable Outbound Call Recording`,
      enableInternal: `Enable Internal Call Recording`,
    },
    toast: {
      saveSuccess: `Settings saved successfully`,
      saveError: `Failed to save settings`,
      validationError: `Cannot save — please fix the errors above`,
    },
    error: {
      loadFailed: `Failed to load system settings. Please try again.`,
    },
  },
}
